/* eslint-disable*/
const COS = require("./cos-js-sdk-v5.js");

export const COSSettings = {
    // 桶名
    Bucket: "ask-003-1388908610",
    Region: "ap-guangzhou",
    SecretId: "AKIDJemiPsKYYLvJD0bCnS3YzDF7mMs1wupb",
    SecretKey: "a6VntmQs8B0cz82iCTVIq9FFH9WxQlTH",
};

const cos = new COS({
    SecretId: COSSettings.SecretId,
    SecretKey: COSSettings.SecretKey,
});


/**
 * @param { putObjectParams }  文件流  putObjectParams.body  文件名  putObjectParams.key  桶名  putObjectParams.Bucket
 * @param { progressFn } 上传进度条回调
*/
export const putObject = (putObjectParams, progressFn) => {
    return new Promise((resolve, reject) => {
        cos.uploadFile({
            Bucket: COSSettings.Bucket,
            Region: COSSettings.Region,
            Key: putObjectParams.Key,
            Body: putObjectParams.Body,

            onProgress: function (progressData) { // 非必须
                progressFn(progressData);
            },
        }, function (err, data) {
            if (err) {
                console.log('上传失败', err);
            } else {
                 resolve({
                    fileAddress: `http://${data.Location}`,
                    name: putObjectParams.Key,
                });
            }
        })
    });
};
